"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Context_1 = require("../../Context");
function useStringValueValidation(name) {
    var _a = (0, Context_1.useFormContext)(), initialValues = _a.initialValues, values = _a.values;
    if (!(name in initialValues && typeof initialValues[name] === 'string')) {
        /*
          cannot have undefined value because it won't trigger formik validation
          and will have error from React 'A component is changing an uncontrolled input to be controlled'
          https://reactjs.org/docs/forms.html#controlled-components
    
          cannot use null as React will throw error `value` prop on `input` should not be null
    
          only option for input is string
          throw Error to raise the bug early
        */
        throw new Error("Field " + name + " needs a default string value in form initialValues");
    }
    if (typeof values[name] !== 'string') {
        throw new Error("Field " + name + " needs string value");
    }
}
exports.default = useStringValueValidation;
